export var TasksType;
(function (TasksType) {
    TasksType["Open"] = "open";
    TasksType["Queued"] = "queued";
    TasksType["Scheduled"] = "scheduled";
    TasksType["Closed"] = "closed";
})(TasksType || (TasksType = {}));
